import cookie from 'js-cookie';
import storage from '@/Common/libs/storage';
import { MessageBox, Loading } from 'hui-intl';
import i18n from '@pro/common/i18n/i18n';
import { getUrlPrefixTip } from './url-tip-constant';
import Vue from 'vue';
import { resetStore, store, mutations } from '@/Common/libs/store';
import { LANGUAGE_OPTIONS } from '@/Common/i18n/i18n-utils';
import { TRANSLATE_HANDLER } from '@/Common/libs/constant';
import bury from '@/Common/bury_point/index';
import eventBus from '@/Common/libs/eventbus';
import logoutOnehikid from '@pro/common/utils/logoutOnehikid';
import { getCookiesOption } from '@/Common/libs/utils';
import { deleteDBAll } from '@pro/common/dao/indexedDB';

const $t = i18n.t;
i18n.t = function (key, options) {
  // eslint-disable-next-line new-cap
  return $t.call(this, TRANSLATE_HANDLER(key, LANGUAGE_OPTIONS), options);
};

/**
 * 清除浏览器本地缓存的用户登录信息
 * @example 如果清除数据后会跳转到落地页，则无需清除store
 */
export const clearLoginInfo = function (type) {
  if (type === 'logout') {
    clearAutoChooseId();
    cookie.remove('portalId');
    cookie.remove('portalAutoLoginId');
  }
  storage.clear();
  // 删除手动升级存储的indexedDB数据
  deleteDBAll('MANUAL_UPDATE');
  eventBus.$emit('no-login', true);
  //   const origin = window.location.origin;
  //   const originReg = /^https?:\/\/[\s\S]*\.?((hik-proconnect|hik-partner|pramaonlinepartnerro|hik-proconnectru).com)(:\d{2,})?$/;
  //   let option = {};
  //   const match = origin.match(originReg);
  //   if (match) {
  //     option = {
  //       path: '/',
  //       domain: `.${match[1]}`,
  //     };
  //   }
  //   console.log('13132cookiecookie');

  let option = getCookiesOption();
  cookie.remove(`${storage.NAME.USER}login`, option);
  cookie.remove('isAuthed', option);
  cookie.remove('emphasisStatus', option);
  cookie.remove('name', option);
  cookie.remove('avatar', option);
  cookie.remove('phone', option);
  cookie.remove('email', option);
  cookie.remove('country', option);
  sessionStorage.setItem('showNotice', true);
};

function clearAutoChooseId() {
  let getAutoInstallerIdObj = JSON.parse(localStorage.getItem('auto_choose_installer_id'));
  // storage.get(storage.NAME.USER).hikId
  if (
    getAutoInstallerIdObj
    && typeof getAutoInstallerIdObj === 'object'
    && Object.keys(getAutoInstallerIdObj).length > 0
  ) {
    delete getAutoInstallerIdObj[
      storage.get(storage.NAME.USER)?.epSessionData?.realHikId || storage.get(storage.NAME.USER)?.hikId
    ];
  }
  localStorage.setItem('auto_choose_installer_id', JSON.stringify(getAutoInstallerIdObj));
}
/**
 * 清除用户登录后的所有登录状态
 */
export const clearLoginState = function (type) {
  resetStore();
  clearLoginInfo(type);
  eventBus.$emit('no-login', true);
};

const errorStrategy = {
  LAP: {
    '001032': () => {
      sessionStorage.removeItem('jump-after-login');//解决js报错Setting the value of 'jump-after-login' exceeded the quota
      sessionStorage.removeItem('jump-after-login-id');
      sessionStorage.setItem('jump-after-login', window.location.href);
      sessionStorage.setItem('jump-after-login-id', sessionStorage.getItem('currentInstallerId'));
      if (!store.touristMode) {
        clearLoginState('logout');
        bury.loginDialog(1, 3);
        logoutOnehikid();
      }
    },
    '002055': () => {
      sessionStorage.removeItem('jump-after-login');//解决js报错Setting the value of 'jump-after-login' exceeded the quota
      sessionStorage.removeItem('jump-after-login-id');
      sessionStorage.setItem('jump-after-login', window.location.href);
      sessionStorage.setItem('jump-after-login-id', sessionStorage.getItem('currentInstallerId'));
      if (!store.touristMode) {
        clearLoginState('logout');
        logoutOnehikid();
        bury.loginDialog(1, 3);
      }
    },
    '001004': () => {
      sessionStorage.removeItem('jump-after-login');//解决js报错Setting the value of 'jump-after-login' exceeded the quota
      sessionStorage.removeItem('jump-after-login-id');
      sessionStorage.setItem('jump-after-login', window.location.href);
      sessionStorage.setItem('jump-after-login-id', sessionStorage.getItem('currentInstallerId'));
      if (!store.touristMode) {
        clearLoginState('relogin');
        logoutOnehikid();
      }
    },
    '007010': () => {
      //刷新页面
      window.location.reload();
    }
  },
  VMS: {
    '002030': () => {
      sessionStorage.removeItem('jump-after-login');//解决js报错Setting the value of 'jump-after-login' exceeded the quota
      sessionStorage.removeItem('jump-after-login-id');
      sessionStorage.setItem('jump-after-login', window.location.href);
      sessionStorage.setItem('jump-after-login-id', sessionStorage.getItem('currentInstallerId'));
      clearLoginState('logout');
      if (!store.touristMode) {
        bury.loginDialog(1, 3);
        logoutOnehikid();
      }
    }
  }
};

// 需要显示技术支持错误提示弹窗的错误码
const USER_UPGRADE_ERRORCODE = ['LAP002032', 'LAP002037', 'LAP054016', 'LAP054009'];

// 获取用户升级错误的技术支持提示
const getUserUpgradeErrorTip = (data, tipPrefix) => {
  mutations.setAreaSupport(data);
  const vnode = new Vue({
    render() {
      return (
        <div>
          {tipPrefix ? <p>{tipPrefix}</p> : ''}
          <p>{i18n.t('HPP-web_contacttiptext_msg')}</p>
          {store.areaSupport.email?.length > 0 ? (
            <div style='display: flex'>
              <span title={i18n.t('e-mail')}>{i18n.t('e-mail')}:</span>
              <p style='margin-left: 4px;display: flex;flex-direction: column'>
                {store.areaSupport.email.map((item) => (
                  <span>{item}</span>
                ))}
              </p>
            </div>
          ) : (
            ''
          )}
          {store.areaSupport.phone?.length > 0 ? (
            <div style='display: flex'>
              <span title={i18n.t('phone')}>{i18n.t('phone')}:</span>
              <p style='margin-left: 4px;display: flex;flex-direction: column'>
                {store.areaSupport.phone.map((item) => (
                  <span>{item}</span>
                ))}
              </p>
            </div>
          ) : (
            ''
          )}
        </div>
      );
    }
  }).$mount();
  return vnode._vnode;
};

const getErrorTip = (errorCode, response) => {
  const commonErrorText = function (eCode) {
    if (i18n.t(eCode) === eCode) {
      if (eCode.slice(0, 17) === 'webcontrol_error_') {
        return `${i18n.t('error_code')}: RWC${eCode.slice(17)}`;
      } else if (eCode.slice(0, 3) === 'EVZ') {
        return `${i18n.t('error_code')}: ${eCode.slice(3)}`;
      }
      return `${i18n.t('error_code')}: ${eCode}`;
    }
    return i18n.t(eCode);
  };
  if (['LAP001004', 'LAP001032', 'LAP002055', 'VMS002030'].includes(errorCode)) {
    //无需url前缀文案的翻译
    return commonErrorText(errorCode);
  } else if (USER_UPGRADE_ERRORCODE.includes(errorCode)) {
    // 用户升级技术支持文案
    return getUserUpgradeErrorTip(response.data.data, i18n.t(errorCode));
  }
  if (response) {
    if (response.config.hasUrlPreFix === false) {
      return commonErrorText(errorCode);
    }
    const urlTipPrefix = getUrlPrefixTip(
      response && response.config && response.config.url,
      response && response.config && response.config.method
    );
    if (urlTipPrefix) {
      if (urlTipPrefix === i18n.t(errorCode)) {
        return `${urlTipPrefix} ${i18n.t('error_code')}: ${errorCode}`;
      }
      return `${urlTipPrefix} ${commonErrorText(errorCode)}`;
    }
  }

  return commonErrorText(errorCode);
};
const hasCommonErrorHandler = (errorCode) => {
  const handler
    = errorStrategy[errorCode.substr(0, 3)] && errorStrategy[errorCode.substr(0, 3)][errorCode.substr(3, 6)];
  if (typeof handler === 'function') {
    return true;
  }
  return false;
};
const handleError = (errorCode) => {
  const handler
    = errorStrategy[errorCode.substr(0, 3)] && errorStrategy[errorCode.substr(0, 3)][errorCode.substr(3, 6)];
  if (typeof handler === 'function') {
    handler();
  }
};

let hintCode = ['LAP002031', 'LAP002032', 'LAP002033'];
const handleErrorAndTip = (errorCode, response) => {
  Loading.service().close();
  if (store.preErrorCode === errorCode) {
    return;
  }
  mutations.setPreErrorCode(errorCode);
  let title = i18n.t('error');
  let type = 'error';
  if (
    errorCode === 'LAP001004'
    || errorCode === 'LAP001032'
    || errorCode === 'LAP002055'
    || errorCode === 'VMS002030'
  ) {
    title = i18n.t('confirm');
    type = 'warning';
  }
  if (hintCode.includes(errorCode)) {
    if (
      errorCode === 'LAP001004'
      || errorCode === 'LAP001032'
      || errorCode === 'LAP002055'
      || errorCode === 'VMS002030'
    ) {
      title = i18n.t('confirm');
      type = 'info';
    }
  }
  // eslint-disable-next-line new-cap
  return MessageBox({
    title,
    type,
    message: getErrorTip(errorCode, response)
  })
    .then(() => {
      handleError(errorCode);
      mutations.setPreErrorCode(null);
    })
    .catch(() => {
      handleError(errorCode);
      mutations.setPreErrorCode(null);
    });
};

const handleCommonError = (errorCode, res) => {
  Loading.service().close();
  if (hasCommonErrorHandler(errorCode)) {
    handleErrorAndTip(errorCode, res);
    return true;
  }
  return false;
};

Vue.prototype.$handleErrorAndTip = handleErrorAndTip; // 错误弹窗并且处理错误
Vue.prototype.$handleCommonError = handleCommonError; // 如果是通用错误，就处理，没有返回 false
Vue.prototype.$getErrorTip = getErrorTip; // 获得错误码的多语言翻译，没有的key会拼接成特定的错误文案返回

export {
  handleError,
  handleErrorAndTip,
  getErrorTip,
  handleCommonError,
  USER_UPGRADE_ERRORCODE,
  getUserUpgradeErrorTip
};
